module.exports = __webpack_public_path__ + "cg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cg.svg
// module id = 486
// module chunks = 0